import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { loginAction } from '../../actions/loginAction';
import { handleTime, getCookie } from '../common/functions';
import { DABInlineLoading } from '../../components/dab'
import { setAuthData } from '../../services/selectors/Accounts';
import moment from 'moment';

interface ILoginProps {
	dispatch: Dispatch<any>;
	loginData: any;
	callback: any;
}

const FrontLogin: React.SFC<ILoginProps> = ({ dispatch, loginData, callback }) => {

	const [user, setUser] = useState({ username: "", password: "",isRememberMe:true, origin:"front" });

	const handleOnChange = (e: any) => {
		const { name, value } = e.target
		setUser({ ...user, [name]: value })
	};

	const handleSubmit = (e: any) => {
		e.preventDefault();
		dispatch(loginAction.loginGetDetail(user));
	};

	if (loginData) {		
		if (loginData.isSuccess && !loginData.isLoading) {
			const loggedIn = localStorage.getItem('AUTHDATA');
			if (!loggedIn) {
				setAuthData(loginData);
				handleTime();
				localStorage.setItem('refreshToken', loginData.refreshToken);
				const days = moment(loginData.expiredAtUtc).get('date') - moment().get('date')
				var expire = new Date();
				expire = new Date(expire.getTime() + 1000 * 60 * 60 * 24 * days);
				window.document.cookie = "refreshToken=" + loginData.refreshToken + ";expires=" + expire + ";path=/";
			}
			callback(true)
			loginData.isSuccess = false;
		}
	}
	return (
		<div>
			{loginData.isLoading ?
				<div className="front-spinner" style={{ height: window.innerHeight - 200 }}> <DABInlineLoading /> </div> :
				< div className='login-page' id="login" data-testid="loginPage">
				{loginData && !loginData.isSuccess && loginData.isError &&
					<div className="alert alert-dismissible alert-danger">
						<text> Username and password combination is incorrect, try again</text>
					</div>}
				<form onSubmit={handleSubmit}>
					<div className="form-group">
						<label htmlFor="username">Email</label>
						<input data-testid="username" name="username" required={true} id="username" type="text"
							className="is-touched is-dirty av-valid form-control" onChange={handleOnChange} />
					</div>
					<div className="form-group">
						<label htmlFor="password">Password</label>
						<input name="password" required={true} id="password" type="password"
							className="is-touched is-dirty av-valid form-control" onChange={handleOnChange} />
					</div>
					<div className="row">
						<button className="btn-submit-frm btn-submit-frmt btn btn-secondary">
							Login
						</button>
					</div>
				</form>
			</div>}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { loginData, userData } = state;
	return { loginData, userData};
};

export default connect(mapStateToProps)(FrontLogin);